<div class="space-y-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 shadow-xs transition-colors">
  <!-- Cabecera y navegación de la sección de créditos -->
  <div>
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-b border-slate-100 dark:border-slate-800 pb-4">
      <div>
        <div class="flex items-center space-x-2">
          <div class="w-8 h-8 rounded-lg bg-emerald-50 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 flex items-center justify-center">
            <app-icon name="dollar-sign" [size]="18" />
          </div>
          <div>
            <p class="text-xs text-slate-500 dark:text-slate-400">
              Línea de liquidez oficial indexada al calendario de competición y amortizable por jornada.
            </p>
          </div>
        </div>
      </div>

      <!-- Quick Balances & Solvency Overview -->
        <!-- Saldo Disponible
        <div class="px-3.5 py-2 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800">
          <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Saldo Disponible</div>
          <div class="text-sm font-mono font-bold" [class.text-emerald-600]="availableBalanceEur() > 0" [class.text-red-600]="availableBalanceEur() < 0">
            {{ formatEur(availableBalanceEur()) }}
          </div>
        </div> -->

        <!-- Saldo Reservado (Inmovilizado) 
        <div class="px-3.5 py-2 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800">
          <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider" title="Inmovilizado por pujas u operaciones en curso. No es gastable ni amortizable.">
            Saldo Reservado ℹ️
          </div>
          <div class="text-sm font-mono font-bold text-slate-700 dark:text-slate-300">
            {{ formatEur(reservedBalanceEur()) }}
          </div>
        </div>-->


        <!-- Botón Refrescar 
        <button
          type="button"
          (click)="refreshAllLoansData(true)"
          [disabled]="isLoading()"
          class="p-2.5 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 transition-all cursor-pointer disabled:opacity-50"
          title="Actualizar datos oficiales de crédito y saldos"
        >
          <span [class.animate-spin]="isLoading()" class="inline-block text-xs">🔄</span>
        </button>-->
    </div>

    <!-- Sub-tabs Navigation -->
    <div class="flex items-center space-x-2 pt-4 overflow-x-auto text-xs font-semibold">
      <button
        type="button"
        (click)="setSubTab('offer')"
        class="px-3.5 py-2 rounded-xl transition-all cursor-pointer flex items-center space-x-1.5"
        [class]="activeSubTab() === 'offer'
          ? 'bg-emerald-600 text-white shadow-xs'
          : 'bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300'"
      >
        <span>Contratar</span>
        @if (offer() && !hasActiveLoan() && !offer()?.ineligibilityReason) {
          <span class="w-2 h-2 rounded-full bg-emerald-300"></span>
        }
      </button>

      <button
        type="button"
        (click)="setSubTab('active')"
        class="px-3.5 py-2 rounded-xl transition-all cursor-pointer flex items-center space-x-1.5"
        [class]="activeSubTab() === 'active'
          ? 'bg-emerald-600 text-white shadow-xs'
          : 'bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300'"
      >
        <span>Préstamo</span>
        @if (hasActiveLoan()) {
          <span class="px-1.5 py-0.2 rounded-md bg-emerald-500 text-white text-[10px] font-bold">ACTIVO</span>
        }
      </button>

      <button
        type="button"
        (click)="setSubTab('history')"
        class="px-3.5 py-2 rounded-xl transition-all cursor-pointer"
        [class]="activeSubTab() === 'history'
          ? 'bg-emerald-600 text-white shadow-xs'
          : 'bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300'"
      >
        Historial
      </button>

      @if (hasLegacyDebt()) {
        <button
          type="button"
          (click)="setSubTab('legacy')"
          class="px-3.5 py-2 rounded-xl transition-all cursor-pointer flex items-center space-x-1"
          [class]="activeSubTab() === 'legacy'
            ? 'bg-amber-600 text-white shadow-xs'
            : 'bg-amber-100/70 hover:bg-amber-200/70 dark:bg-amber-950/50 dark:hover:bg-amber-900/50 text-amber-800 dark:text-amber-300'"
        >
          <span>Deuda Histórica</span>
          <span class="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
        </button>
      }
    </div>
  </div>

  <!-- Server/Form Error Banner -->
  @if (formError() || serverError()) {
    <div class="p-4 rounded-2xl bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800/60 text-red-800 dark:text-red-300 text-xs flex items-start space-x-3">
      <app-icon name="alert-circle" [size]="18" class="text-red-600 dark:text-red-400 shrink-0 mt-0.5" />
      <div class="flex-1">
        <strong class="font-bold block">Aviso del sistema crediticio:</strong>
        <span>{{ formError() || serverError() }}</span>
      </div>
    </div>
  }

  <!-- ============================================================= -->
  <!-- TAB 1: OFERTA Y CONTRATACIÓN -->
  <!-- ============================================================= -->
  @if (activeSubTab() === 'offer') {
    <div class="space-y-6">
      <!-- Caso 1: Ya dispone de un préstamo activo -->
      @if (hasActiveLoan(); as currentLoan) {
        <div class="py-2">
          <div class="max-w-xl mx-auto text-center space-y-4 py-4">
            <div class="w-14 h-14 rounded-2xl bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400 flex items-center justify-center mx-auto">
              <app-icon name="check-circle" [size]="28" />
            </div>
            <div>
              <h3 class="text-base font-bold text-slate-900 dark:text-white">Ya tienes un préstamo activo</h3>
              <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
                La normativa oficial de la competición prohíbe acumular más de un crédito por jornada de forma simultánea.
                Tu club dispone de un crédito vigente de
                <strong class="text-slate-900 dark:text-white">{{ formatEur(activeLoan()?.outstandingPrincipal) }}</strong> pendientes.
              </p>
            </div>
            <div class="pt-2 flex justify-center">
              <button
                type="button"
                (click)="setSubTab('active')"
                class="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-semibold text-xs rounded-xl shadow-xs transition-all cursor-pointer flex items-center space-x-2"
              >
                <span>Ver y Amortizar Préstamo Activo</span>
                <app-icon name="chevron-right" [size]="14" />
              </button>
            </div>
          </div>
        </div>
      } @else if (offer()?.ineligibilityReason; as reason) {
        <!-- Caso 2: Inelegibilidad por causas reglamentarias (NO_CALENDAR, EXISTING_DEBT, CLOSING, SEASON_END) -->
        @let expl = getIneligibilityExplanation(reason);
        <div class="bg-amber-50/70 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800/60 rounded-2xl p-6 shadow-xs">
          <div class="flex items-start space-x-3.5">
            <div class="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-300 flex items-center justify-center shrink-0">
              <app-icon [name]="expl.icon" [size]="20" />
            </div>
            <div class="space-y-1">
              <span class="inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-amber-200 dark:bg-amber-900 text-amber-900 dark:text-amber-200">
                Inelegible: {{ reason }}
              </span>
              <h3 class="text-sm font-bold text-amber-900 dark:text-amber-200">{{ expl.title }}</h3>
              <p class="text-xs text-amber-800/90 dark:text-amber-300/90 leading-relaxed">
                {{ expl.desc }}
              </p>
            </div>
          </div>
        </div>
      } @else {
        <!-- Caso 3: Oferta elegible y formulario de contratación -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- Columna Izquierda: Tarjetas de Condiciones Oficiales -->
          <div class="lg:col-span-1 space-y-4">
            <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs">
              <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
                <h3 class="text-sm font-bold text-slate-900 dark:text-white">Condiciones de Oferta</h3>
                <!--@if (offer()?.tier) {
                  <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                    {{ getTierLabel(offer()?.tier) }}
                  </span>
                }-->
              </div>

              <!-- Límite de Capital -->
              <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800/80">
                <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Capital Máximo Autorizado</div>
                <div class="text-lg font-mono font-black text-slate-900 dark:text-white mt-0.5">
                  {{ formatEur(offer()?.maximumPrincipal) }}
                </div>
                <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-1">
                  Basado en la posición y solvencia oficial del club.
                </div>
              </div>

              <!-- Tipo de Interés por Jornada (CRÍTICO: % por jornada, NUNCA TAE) -->
              <div class="p-3.5 bg-emerald-50/70 dark:bg-emerald-950/40 rounded-xl border border-emerald-200/80 dark:border-emerald-800/60">
                <div class="text-[10px] uppercase font-bold text-emerald-700 dark:text-emerald-400 tracking-wider">
                  Tipo de Interés Fijo
                </div>
                <div class="text-lg font-mono font-black text-emerald-800 dark:text-emerald-300 mt-0.5">
                  {{ formatRate(offer()?.ratePerMatchday) }}
                </div>
                <div class="text-[11px] text-emerald-700/80 dark:text-emerald-400/80 mt-1">
                  Se aplica exclusivamente sobre el capital pendiente al cierre de cada jornada.
                </div>
              </div>

              <!-- Plazo Máximo -->
              <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800/80">
                <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Vencimiento Fijo</div>
                <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
                  Jornada {{ contractMaturityMatchday() }} · Penúltima de la temporada
                </div>
                <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-1">
                  Jornadas restantes en la temporada: {{ offer()?.remainingMatchdays ?? offer()?.calendar?.remaining ?? 0 }}.
                </div>
              </div>
            </div>

            <!-- Aviso Reglamentario de Consecuencias del Descubierto -->
            <div class="p-4 rounded-2xl bg-amber-50 dark:bg-amber-950/30 border border-amber-200/80 dark:border-amber-800/60 text-amber-900 dark:text-amber-200 text-xs space-y-2">
              <div class="flex items-center space-x-1.5 font-bold">
                <app-icon name="alert-circle" [size]="16" class="text-amber-600 dark:text-amber-400 shrink-0" />
                <span>Normativa Oficial de Descubierto</span>
              </div>
              <p class="text-[11px] leading-relaxed text-amber-800 dark:text-amber-300">
                Al cierre de la jornada de vencimiento, todo el capital pendiente y sus intereses se cobran de forma obligatoria. Si la tesorería queda en descubierto (saldo negativo):
              </p>
              <ul class="list-disc list-inside text-[11px] text-amber-800 dark:text-amber-300 space-y-1">
                <li>El club con saldo negativo <strong>pierde 0-3</strong> en su encuentro oficial.</li>                
              </ul>
            </div>
          </div>

          <!-- Columna Derecha: Formulario de Contratación -->
          <div class="lg:col-span-2">
            <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-xs space-y-6">
              <div>
                <h3 class="text-base font-bold text-slate-900 dark:text-white">Simular y Contratar Crédito</h3>
                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                  Elige el capital a ingresar. El vencimiento queda fijado en la penúltima jornada.
                </p>
              </div>

              <!-- Selección de Capital -->
              <div class="space-y-2">
                <div class="flex items-center justify-between text-xs font-semibold">
                  <label for="input-loan-principal" class="text-slate-700 dark:text-slate-300">
                    Capital Solicitado (EUR)
                  </label>
                  <span class="text-slate-400 text-[11px]">
                    Máx: {{ formatEur(offer()?.maximumPrincipal) }}
                  </span>
                </div>

                <div class="relative">
                  <input
                    id="input-loan-principal"
                    type="text" inputmode="decimal" appMoneyInput
                    step="1000"
                    min="1000"
                    [attr.max]="offer()?.maximumPrincipal || 3000000"
                    [ngModel]="requestedPrincipal()"
                    (ngModelChange)="setRequestedPrincipal($event)"
                    class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-base font-mono font-bold text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
                    placeholder="1000000"
                  />
                  <span class="absolute right-4 top-1/2 -translate-y-1/2 font-bold text-slate-400 text-sm">€</span>
                </div>

                <!-- Botones rápidos de porcentaje -->
                <div class="flex items-center space-x-2 pt-1">
                  <button
                    type="button"
                    (click)="setPrincipalPercentage(25)"
                    class="px-2.5 py-1 text-[11px] font-semibold bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg cursor-pointer"
                  >
                    25%
                  </button>
                  <button
                    type="button"
                    (click)="setPrincipalPercentage(50)"
                    class="px-2.5 py-1 text-[11px] font-semibold bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg cursor-pointer"
                  >
                    50%
                  </button>
                  <button
                    type="button"
                    (click)="setPrincipalPercentage(75)"
                    class="px-2.5 py-1 text-[11px] font-semibold bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg cursor-pointer"
                  >
                    75%
                  </button>
                  <button
                    type="button"
                    (click)="setPrincipalPercentage(100)"
                    class="px-2.5 py-1 text-[11px] font-semibold bg-emerald-50 hover:bg-emerald-100 dark:bg-emerald-950/60 dark:hover:bg-emerald-900/60 text-emerald-700 dark:text-emerald-300 rounded-lg cursor-pointer font-mono"
                  >
                    100% Máximo
                  </button>
                </div>
              </div>

              <p class="text-xs text-slate-500 dark:text-slate-400">
                El crédito vence al cierre de la penúltima jornada de la temporada.
                Puedes amortizar capital parcial o totalmente cuando decidas antes del vencimiento.
              </p>

              <!-- Cuadro de Simulación Previa -->
              <div class="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 text-xs space-y-2.5">
                <div class="font-bold text-slate-900 dark:text-white border-b border-slate-200/60 dark:border-slate-800 pb-2">
                  Resumen de la Simulación
                </div>
                <div class="flex justify-between items-center text-slate-600 dark:text-slate-400">
                  <span>Capital a ingresar de inmediato:</span>
                  <strong class="font-mono text-emerald-600 dark:text-emerald-400 font-bold">
                    +{{ formatEur(requestedPrincipal()) }}
                  </strong>
                </div>
                <div class="flex justify-between items-center text-slate-600 dark:text-slate-400">
                  <span>Tipo de interés aplicable:</span>
                  <strong class="font-mono text-slate-900 dark:text-white">
                    {{ formatRate(offer()?.ratePerMatchday) }} (fijo)
                  </strong>
                </div>
                <div class="flex justify-between items-center text-slate-600 dark:text-slate-400">
                  <span>Interés estimado por jornada:</span>
                  <strong class="font-mono text-slate-900 dark:text-white">
                    {{ formatEur(requestedPrincipal() * (offer()?.ratePerMatchday ?? 0.01)) }}
                  </strong>
                </div>
                <div class="flex justify-between items-center text-slate-600 dark:text-slate-400">
                  <span>Interés total estimado (sin amortizaciones):</span>
                  <strong class="font-mono text-amber-600 dark:text-amber-400 font-bold">
                    ~{{ formatEur(estimatedContractInterest()) }}
                  </strong>
                </div>
                <div class="flex justify-between items-center text-slate-600 dark:text-slate-400 pt-1 border-t border-slate-200/60 dark:border-slate-800">
                  <span>Vencimiento obligatorio de capital e intereses:</span>
                  <strong class="text-slate-900 dark:text-white">
                    Al cierre de la jornada {{ contractMaturityMatchday() }}
                  </strong>
                </div>
              </div>

              <!-- Botón Solicitar y Contratar -->
              <button
                type="button"
                (click)="openContractConfirmModal()"
                [disabled]="isSubmitting() || requestedPrincipal() <= 0 || requestedPrincipal() > (offer()?.maximumPrincipal || 0)"
                class="w-full py-3 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-bold text-sm rounded-xl shadow-xs transition-all cursor-pointer active:scale-98 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
              >
                <span>Solicitar Concesión de Crédito</span>
                <app-icon name="chevron-right" [size]="16" />
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- ============================================================= -->
  <!-- TAB 2: PRÉSTAMO ACTIVO Y AMORTIZACIÓN -->
  <!-- ============================================================= -->
  @if (activeSubTab() === 'active') {
    <div class="space-y-6">
      @if (activeLoan(); as loan) {
        <div class="space-y-6">
          <!-- Top Row: Estado y Claves del Préstamo -->
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b border-slate-100 dark:border-slate-800 pb-4">
            <div>
              <h3 class="text-xl font-mono font-black text-slate-900 dark:text-white mt-2">
                {{ formatEur(loan.outstandingPrincipal) }}
                <span class="text-xs font-sans font-normal text-slate-400">capital pendiente</span>
              </h3>
            </div>

            <!-- Botón Amortizar -->
            @if (loan.status === 'ACTIVE' && loan.outstandingPrincipal > 0) {
              <div class="flex items-center space-x-3">
                <button
                  type="button"
                  (click)="openRepayModal()"
                  [disabled]="availableBalanceEur() <= 0"
                  class="px-4 py-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold text-xs rounded-xl shadow-xs transition-all cursor-pointer flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span>Amortizar Capital Anticipado</span>
                </button>
              </div>
            }
          </div>

          <!-- Métricas del Préstamo Activo (Grid) -->
          <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800/80">
              <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Capital Concedido</div>
              <div class="text-sm font-mono font-bold text-slate-900 dark:text-white mt-1">
                {{ formatEur(loan.principal) }}
              </div>
            </div>

            <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800/80">
              <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Tipo Congelado</div>
              <div class="text-sm font-mono font-bold text-emerald-600 dark:text-emerald-400 mt-1">
                {{ formatRate(loan.ratePerMatchday) }}
              </div>
            </div>

            <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800/80">
              <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Próximo Interés</div>
              <div class="text-sm font-mono font-bold text-amber-600 dark:text-amber-400 mt-1">
                {{ formatEur(loan.nextInterest) }}
              </div>
            </div>

            <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800/80">
              <div class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Jornada Vencimiento</div>
              <div class="text-sm font-bold text-purple-700 dark:text-purple-400 mt-1">
                Jornada {{ loan.maturityMatchday }}
              </div>
            </div>
          </div>

          <!-- AVISO DE VENCIMIENTO OBLIGATORIO (CRITERIO DE ACEPTACIÓN 8) -->
          <div class="p-4 rounded-xl bg-purple-50 dark:bg-purple-950/40 border border-purple-200 dark:border-purple-800/60 text-xs space-y-2">
            <div class="flex items-center space-x-2 font-bold text-purple-900 dark:text-purple-200">
              <app-icon name="calendar" [size]="16" class="text-purple-600 dark:text-purple-400 shrink-0" />
              <span>Vencimiento: Jornada {{ loan.maturityMatchday }}</span>
            </div>
            <p class="text-purple-900/90 dark:text-purple-300 leading-relaxed">
              Al cierre de la <strong>Jornada {{ loan.maturityMatchday }}</strong>, el sistema debitará automáticamente la totalidad del capital pendiente restante <strong>({{ formatEur(loan.outstandingPrincipal) }})</strong> más los intereses devengados de esa jornada.
            </p>
          </div>

          <!-- Movimientos del Préstamo Activo -->
          @if (loan.movements && loan.movements.length > 0) {
            <div class="space-y-3 pt-2">
              <h4 class="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                Movimientos del Préstamo Activo
              </h4>
              <div class="border border-slate-200 dark:border-slate-800 rounded-xl">
                <table class="w-full table-fixed text-xs text-left">
                  <caption class="sr-only">Movimientos del préstamo activo</caption>
                  <thead class="bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 text-[10px] uppercase tracking-wider">
                    <tr>
                      <th scope="col" class="px-2 py-2.5 sm:px-3 font-bold w-[28%]">Fecha</th>
                      <th scope="col" class="px-2 py-2.5 sm:px-3 font-bold">Concepto</th>
                      <th scope="col" class="px-2 py-2.5 sm:px-3 font-bold text-right w-[36%]">Importe</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-slate-50/50 dark:bg-slate-950/30">
                    @for (mov of loan.movements; track mov.id || $index) {
                      @let movMeta = getMovementLabel(mov.type);
                      <tr>
                        <td class="px-2 py-2.5 sm:px-3 text-slate-500 dark:text-slate-400 whitespace-nowrap">
                          @let movementDate = mov.createdAt || mov.date || mov.occurredAt;
                          @if (movementDate) {
                            <div class="text-[11px] font-semibold">{{ movementDate | date:'dd/MM/yy' }}</div>
                            <div class="text-[10px] text-slate-400 dark:text-slate-500">{{ movementDate | date:'HH:mm' }}</div>
                          } @else {
                            —
                          }
                        </td>
                        <td class="px-2 py-2.5 sm:px-3 text-slate-700 dark:text-slate-300 font-medium [overflow-wrap:anywhere]">
                          {{ mov.description || movMeta.label }}
                        </td>
                        <td class="px-2 py-2.5 sm:px-3 text-right font-mono font-bold [overflow-wrap:anywhere]" [class.text-emerald-600]="mov.type === 'DISBURSEMENT'" [class.text-amber-600]="mov.type === 'INTEREST'" [class.text-blue-600]="mov.type.includes('REPAYMENT')">
                          {{ mov.type === 'DISBURSEMENT' ? '+' : '-' }}{{ formatEur(mov.amount) }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      } @else {
        <!-- Sin préstamo activo -->
        <div class="py-6 text-center space-y-4">
          <div class="w-12 h-12 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-400 flex items-center justify-center mx-auto">
            <app-icon name="dollar-sign" [size]="24" />
          </div>
          <div>
            <h3 class="text-sm font-bold text-slate-900 dark:text-white">No tienes préstamos activos</h3>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Tu club no dispone de deuda por créditos de jornada vigente. Puedes consultar las condiciones de contratación en la pestaña de Oferta.
            </p>
          </div>
          <button
            type="button"
            (click)="setSubTab('offer')"
            class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-xs rounded-xl transition-all cursor-pointer"
          >
            Ver Oferta de Crédito
          </button>
        </div>
      }
    </div>
  }

  <!-- ============================================================= -->
  <!-- TAB 3: HISTORIAL DE PRÉSTAMOS Y MOVIMIENTOS -->
  <!-- ============================================================= -->
  @if (activeSubTab() === 'history') {
    <div class="space-y-5">
      <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white">Historial de Financiación por Jornada</h3>
          <p class="text-xs text-slate-500 dark:text-slate-400">
            Registro cronológico oficial. La financiación constituye liquidez de tesorería y no ingreso operativo.
          </p>
        </div>
        <div class="text-xs font-semibold text-slate-500">
          Página {{ historyPage() + 1 }}
        </div>
      </div>

      @if (history() && history().length > 0) {
        <div class="divide-y divide-slate-100 dark:divide-slate-800 border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden text-xs">
          @for (item of history(); track item.id || $index) {
            <div class="p-4 bg-slate-50/50 dark:bg-slate-950/30 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div class="space-y-1">
                <div class="flex items-center space-x-2">
                  <span
                    class="px-2 py-0.5 rounded text-[10px] font-bold"
                    [class]="item.status === 'ACTIVE'
                      ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300'
                      : 'bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-400'"
                  >
                    {{ item.status === 'ACTIVE' ? 'ACTIVO' : 'LIQUIDADO' }}
                  </span>
                  <span class="font-bold text-slate-900 dark:text-white text-sm">
                    {{ formatEur(item.principal) }}
                  </span>
                  <span class="text-slate-400 text-xs">· Tipo: {{ formatRate(item.ratePerMatchday) }}</span>
                </div>
                <div class="text-[11px] text-slate-500 dark:text-slate-400">
                  Plazo: {{ item.termMatchdays ?? (item.maturityMatchday - item.firstMatchday + 1) }} jornadas
                  · Devengo desde Jornada {{ item.firstMatchday }} hasta Vencimiento en Jornada {{ item.maturityMatchday }}
                </div>
              </div>

              <div class="flex items-center space-x-3">
                <div class="text-right">
                  <div class="text-[10px] uppercase font-bold text-slate-400">Pendiente</div>
                  <div class="font-mono font-bold text-slate-900 dark:text-white">
                    {{ formatEur(item.outstandingPrincipal) }}
                  </div>
                </div>
                @if (item.movements && item.movements.length > 0) {
                  <button
                    type="button"
                    (click)="openMovementsModal(item)"
                    class="px-3 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-[11px] transition-all cursor-pointer"
                  >
                    Ver Movimientos ({{ item.movements.length }})
                  </button>
                }
              </div>
            </div>
          }
        </div>

        <!-- Paginación: sin inventar total, paginando array directo -->
        <div class="flex items-center justify-between pt-2">
          <button
            type="button"
            (click)="loadHistoryPage(historyPage() - 1)"
            [disabled]="historyPage() === 0 || isLoading()"
            class="px-4 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-xs disabled:opacity-40 cursor-pointer disabled:cursor-not-allowed"
          >
            ← Página Anterior
          </button>
          <button
            type="button"
            (click)="loadHistoryPage(historyPage() + 1)"
            [disabled]="!hasMoreHistory() || isLoading()"
            class="px-4 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-xs disabled:opacity-40 cursor-pointer disabled:cursor-not-allowed"
          >
            Página Siguiente →
          </button>
        </div>
      } @else {
        <div class="p-8 text-center text-slate-400 text-xs">
          No existen operaciones de crédito en el historial del club.
        </div>
      }
    </div>
  }

  <!-- ============================================================= -->
  <!-- TAB 4: DEUDA HISTÓRICA (LEGACY LOANS) -->
  <!-- ============================================================= -->
  @if (activeSubTab() === 'legacy' && hasLegacyDebt()) {
    <div class="bg-amber-50/60 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800/60 rounded-2xl p-6 shadow-xs space-y-4">
      <div class="flex items-start space-x-3">
        <app-icon name="alert-circle" [size]="20" class="text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
        <div>
          <h3 class="text-sm font-bold text-amber-900 dark:text-amber-200">Deuda Bancaria Histórica (Préstamos Antiguos)</h3>
          <p class="text-xs text-amber-800 dark:text-amber-300 mt-1 leading-relaxed">
            Tu club mantiene deuda acumulada bajo el modelo financiero previo. Conforme al contrato normativo, el endpoint <code>/legacy-loans</code> ya no permite nuevas contrataciones (HTTP 410 Gone) ni admite plazos o amortizaciones del nuevo modelo de créditos por jornada.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
        <div class="p-3.5 bg-white dark:bg-slate-900 rounded-xl border border-amber-200 dark:border-amber-800/60">
          <div class="text-[10px] uppercase font-bold text-slate-400">Capital Histórico Pendiente</div>
          <div class="text-base font-mono font-bold text-amber-800 dark:text-amber-300 mt-0.5">
            {{ formatEur(debt()?.legacyLoansDebt) }}
          </div>
        </div>

        <div class="p-3.5 bg-white dark:bg-slate-900 rounded-xl border border-amber-200 dark:border-amber-800/60">
          <div class="text-[10px] uppercase font-bold text-slate-400">Deuda Total Agregada</div>
          <div class="text-base font-mono font-bold text-slate-900 dark:text-white mt-0.5">
            {{ formatEur(debt()?.totalDebt) }}
          </div>
        </div>
      </div>

      @if (debt()?.nextInstallments && debt()!.nextInstallments!.length > 0) {
        <div class="space-y-2 pt-2">
          <div class="text-xs font-bold text-slate-700 dark:text-slate-300">Cronograma de Cuotas Históricas</div>
          <div class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 text-xs overflow-hidden">
            @for (inst of debt()!.nextInstallments!; track inst.installmentNumber || $index) {
              <div class="p-3 flex justify-between items-center">
                <span>Cuota #{{ inst.installmentNumber ?? ($index + 1) }} @if (inst.season) { (Temporada {{ inst.season }}) }</span>
                <strong class="font-mono text-slate-900 dark:text-white">{{ formatEur(inst.amount) }}</strong>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- ============================================================= -->
<!-- MODAL DE CONFIRMACIÓN DE CONTRATACIÓN -->
<!-- ============================================================= -->
@if (isConfirmContractModalOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-fade-in">
    <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-6 max-w-lg w-full shadow-xl space-y-5">
      <div class="flex items-center space-x-3 text-slate-900 dark:text-white">
        <div class="w-10 h-10 rounded-xl bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400 flex items-center justify-center">
          <app-icon name="dollar-sign" [size]="20" />
        </div>
        <div>
          <h3 class="text-base font-bold">Confirmar Solicitud de Crédito</h3>
          <p class="text-xs text-slate-500 dark:text-slate-400">Revisa las condiciones vinculantes antes de formalizar la operación.</p>
        </div>
      </div>

      <div class="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 text-xs space-y-2">
        <div class="flex justify-between items-center">
          <span class="text-slate-500">Capital a ingresar:</span>
          <strong class="font-mono text-emerald-600 font-bold text-sm">+{{ formatEur(requestedPrincipal()) }}</strong>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-slate-500">Vencimiento fijo:</span>
          <strong class="text-slate-900 dark:text-white">Jornada {{ contractMaturityMatchday() }} (penúltima)</strong>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-slate-500">Tipo de interés congelado:</span>
          <strong class="font-mono text-slate-900 dark:text-white">{{ formatRate(offer()?.ratePerMatchday) }}</strong>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-slate-500">Interés estimado:</span>
          <strong class="font-mono text-amber-600">~{{ formatEur(estimatedContractInterest()) }}</strong>
        </div>
      </div>

      <!-- Cláusulas Contractuales Obligatorias -->
      <div class="p-3 bg-amber-50 dark:bg-amber-950/40 rounded-xl border border-amber-200 dark:border-amber-800/60 text-[11px] text-amber-900 dark:text-amber-200 space-y-1.5 leading-relaxed">
        <div>📌 <strong>Tipo fijo:</strong> El tipo por jornada queda congelado durante toda la vigencia del préstamo.</div>
        <div>📌 <strong>Amortizaciones:</strong> Las amortizaciones anticipadas reducen el capital pendiente y los intereses de futuras jornadas.</div>
        <div>⚠️ <strong>Vencimiento obligatorio:</strong> Al cierre de la penúltima jornada de la temporada se liquidará automáticamente el capital restante y sus intereses. Si el saldo entra en descubierto, el club perderá su partido por 0-3.</div>
      </div>

      @if (formError()) {
        <div class="p-3 bg-red-50 text-red-700 rounded-lg text-xs font-medium">
          {{ formError() }}
        </div>
      }

      <div class="flex items-center justify-end space-x-3 pt-2">
        <button
          type="button"
          (click)="closeContractConfirmModal()"
          [disabled]="isSubmitting()"
          class="px-4 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-xs cursor-pointer"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="confirmAndSubmitLoanContract()"
          [disabled]="!game.canAction('borrow') || (isSubmitting())"
          class="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-bold text-xs shadow-xs transition-all cursor-pointer flex items-center space-x-2 disabled:opacity-50"
        >
          @if (isSubmitting()) {
            <span class="animate-spin text-xs">⏳</span>
            <span>Contratando...</span>
          } @else {
            <span>Aceptar y Contratar Crédito</span>
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- ============================================================= -->
<!-- MODAL DE AMORTIZACIÓN VOLUNTARIA DE CAPITAL -->
<!-- ============================================================= -->
@if (isRepayModalOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-fade-in">
    <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-6 max-w-lg w-full shadow-xl space-y-5">
      <div class="flex items-center space-x-3 text-slate-900 dark:text-white">
        <div class="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400 flex items-center justify-center">
          <app-icon name="dollar-sign" [size]="20" />
        </div>
        <div>
          <h3 class="text-base font-bold">Amortizar Capital Anticipadamente</h3>
          <p class="text-xs text-slate-500 dark:text-slate-400">Sin comisiones. Reduce intereses devengados en las próximas jornadas.</p>
        </div>
      </div>

      <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 text-xs space-y-1.5">
        <div class="flex justify-between">
          <span class="text-slate-500">Capital pendiente actual:</span>
          <strong class="font-mono text-slate-900 dark:text-white">{{ formatEur(activeLoan()?.outstandingPrincipal) }}</strong>
        </div>
        <div class="flex justify-between">
          <span class="text-slate-500">Saldo disponible en tesorería:</span>
          <strong class="font-mono text-emerald-600">{{ formatEur(availableBalanceEur()) }}</strong>
        </div>
        <div class="flex justify-between pt-1 border-t border-slate-200/60 dark:border-slate-800">
          <span class="text-slate-500">Máximo voluntario amortizable hoy:</span>
          <strong class="font-mono text-blue-600 dark:text-blue-400">{{ formatEur(maxRepayableAmount()) }}</strong>
        </div>
      </div>

      <div class="space-y-2">
        <label for="input-repay-amount" class="block text-xs font-semibold text-slate-700 dark:text-slate-300">
          Importe a Amortizar (EUR)
        </label>
        <div class="relative">
          <input
            id="input-repay-amount"
            type="text" inputmode="decimal" appMoneyInput
            step="1000"
            min="1"
            [attr.max]="maxRepayableAmount()"
            [(ngModel)]="repayAmount"
            class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-base font-mono font-bold text-blue-600 dark:text-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          />
          <span class="absolute right-4 top-1/2 -translate-y-1/2 font-bold text-slate-400 text-sm">€</span>
        </div>

        <!-- Botones rápidos de amortización -->
        <div class="flex items-center space-x-2 pt-1">
          <button
            type="button"
            (click)="setRepayPercentage(25)"
            class="px-2.5 py-1 text-[11px] font-semibold bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg cursor-pointer"
          >
            25%
          </button>
          <button
            type="button"
            (click)="setRepayPercentage(50)"
            class="px-2.5 py-1 text-[11px] font-semibold bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg cursor-pointer"
          >
            50%
          </button>
          <button
            type="button"
            (click)="setRepayPercentage(100)"
            class="px-2.5 py-1 text-[11px] font-semibold bg-blue-50 hover:bg-blue-100 dark:bg-blue-950/60 text-blue-700 dark:text-blue-300 rounded-lg cursor-pointer font-mono"
          >
            100% Máximo
          </button>
        </div>
      </div>

      @if (formError()) {
        <div class="p-3 bg-red-50 text-red-700 rounded-lg text-xs font-medium">
          {{ formError() }}
        </div>
      }

      <div class="flex items-center justify-end space-x-3 pt-2">
        <button
          type="button"
          (click)="closeRepayModal()"
          [disabled]="isSubmitting()"
          class="px-4 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-xs cursor-pointer"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="confirmAndSubmitRepayment()"
          [disabled]="!game.canAction('repayLoan') || isSubmitting() || repayAmount() <= 0 || repayAmount() > maxRepayableAmount()"
          class="px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-bold text-xs shadow-xs transition-all cursor-pointer flex items-center space-x-2 disabled:opacity-50"
        >
          @if (isSubmitting()) {
            <span class="animate-spin text-xs">⏳</span>
            <span>Amortizando...</span>
          } @else {
            <span>Confirmar Amortización</span>
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- ============================================================= -->
<!-- MODAL DE DETALLE DE MOVIMIENTOS HISTÓRICOS -->
<!-- ============================================================= -->
@if (isMovementModalOpen() && selectedLoanForDetail(); as detLoan) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-fade-in">
    <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-6 max-w-xl w-full shadow-xl space-y-4">
      <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white">Movimientos del Préstamo</h3>
          <p class="text-xs text-slate-500 font-mono">ID: {{ detLoan.id }}</p>
        </div>
        <button
          type="button"
          (click)="closeMovementsModal()"
          class="text-slate-400 hover:text-slate-600 text-lg cursor-pointer"
        >
          ✕
        </button>
      </div>

      <div class="max-h-80 overflow-y-auto divide-y divide-slate-100 dark:divide-slate-800 border border-slate-200 dark:border-slate-800 rounded-xl text-xs">
        @for (m of detLoan.movements || []; track m.id || $index) {
          @let mMeta = getMovementLabel(m.type);
          <div class="p-3.5 flex items-center justify-between">
            <div class="space-y-0.5">
              <div class="flex items-center space-x-2">
                <span class="px-2 py-0.5 rounded text-[10px] font-bold border" [class]="mMeta.badgeClass">
                  {{ mMeta.label }}
                </span>
                <span class="font-medium text-slate-800 dark:text-slate-200">{{ m.description || mMeta.label }}</span>
              </div>
              <div class="text-[10px] text-slate-400">
                @if (m.matchday !== undefined) { Jornada {{ m.matchday }} · }
                @if (m.date || m.occurredAt) { {{ (m.date || m.occurredAt) | date:'short' }} }
              </div>
            </div>
            <div class="font-mono font-bold text-right" [class.text-emerald-600]="m.type === 'DISBURSEMENT'" [class.text-amber-600]="m.type === 'INTEREST'" [class.text-blue-600]="m.type.includes('REPAYMENT')">
              {{ m.type === 'DISBURSEMENT' ? '+' : '-' }}{{ formatEur(m.amount) }}
            </div>
          </div>
        }
      </div>

      <div class="flex justify-end pt-2">
        <button
          type="button"
          (click)="closeMovementsModal()"
          class="px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-xs rounded-xl cursor-pointer"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
}
